import React from "react";

const Outlet: React.FC<{ data: any }> = ({
    data,
}) => {
    return (
        <div style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            padding: "1.5rem"
        }}>
            <div>
                <span style={{
                    fontWeight: "bold",
                    color: "white",
                    backgroundColor: data.isOpen ? "#10B981" : "#EF4444",
                    borderRadius: 5,
                    padding: 5,
                    paddingLeft: 10,
                    paddingRight: 10,
                    marginLeft: -5,
                    marginBottom: 5,
                }}>{data.isOpen ? "Open" : "Closed"}</span></div>
            <h4 style={{ margin: 0, marginTop: "1rem" }}>{data.name}</h4>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <p>{data?.shortDescription}</p>
                {data?.websiteURL ? <a href={data.websiteURL}>Learn More</a> : null}
            </div>
        </div>
    );
};

export default Outlet;
